import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'
import { Layout } from 'components'
import * as Boxes from 'components/theme/Boxes'
import { SEO } from 'components/common'
import { ProgressCircle } from 'components/theme/Elements'
import { PageWrapper, Section, RowSmallGap, Column4 } from 'components/theme/Layout'
import { Content } from 'components/theme/Content'
import CircularProgress from '@material-ui/core/CircularProgress';
import AOS from 'aos';
import * as Cta from 'components/common/Cta'

const HeadlineLogo = styled.div`
  display: flex;
  justify-content: center;
  img {
    max-width: 30rem;
  }
`;

export default class extends React.Component {

  componentDidMount() {
    AOS.init({
      duration: 1000,
      once: true
    })
  }

  UNSAFE_componentWillReceiveProps() {
    AOS.refresh();
  }

  render() {
    const { pageContext, location, data } = this.props;
    const backgrounds = {
      'default': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_1')[0].node,
      'footer': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_2')[0].node
    };

    return (
      <Layout context={pageContext} location={location} menuLayout="light">
        <SEO />
        <PageWrapper>
          <Section className="bottom">
            <HeadlineLogo>
              <img src={data.logo.edges[0].node.publicURL} alt="manomano" />
            </HeadlineLogo>
          </Section>
          <Section className="top">
            <div>
              <Boxes.BoxLargeShadow data-aos="fade-up" style={{ float: 'none', margin: '2rem auto 0' }}>
                <div>
                  <Content className="center">
                    <p>
                      <span style={{ fontSize: '2.1rem' }}>
                        Épater les passants avec une campagne événementielle dans deux très beaux flagship stores au coeur du Marais.
                      </span><br />
                      Référencer nos nouvelles gammes de montres Casio et G'Shock
                    </p>
                  </Content>
                </div>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>

          <Section className="top">
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'relative' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'absolute',
                  width: '100%',
                  top: '-1.2rem'
                }}>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months className="blue">J</Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                </div>
              </div>
              <hr />
            </div>
          </Section>

          <Section className="bottom">
            <div>
              <Boxes.BoxDefault style={{ float: 'none', margin: '0 auto', minHeight: 0 }}>
                <Content className="padding s center">
                  <p style={{ fontSize: '2rem' }}>
                    "Campagne menée de bout en bout intégrant la recherche des flagship stores,
                    la création graphique et jusqu'à la mise en place opérationnelle du dispositif"
                  </p>
                  <span className="author"><strong>Xavier</strong>, directeur</span>
                </Content>
              </Boxes.BoxDefault>
            </div>
          </Section>

          <Section>
            <div style={{ width: 800, height: 460, margin: '0 auto' }}>
              <video controls style={{
                outline: 'none',
                display: 'inline-block',
                width: '800px',
                margin: '0 auto'
              }}>
                <source src={`${pageContext.PUBLIC_URL}/videos/Fleux_Casio_micro-trottoir.mp4`} />
              </video>
            </div>
          </Section>

          <Section className="top main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
          }}>
            <div>
              <RowSmallGap>
                <Column4 className="smallGap" style={{ paddingLeft: 0 }}>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Réseau</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>2<small></small></span>
                          <span>commerces</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={40} />
                    </ProgressCircle>
                    <Content className="padding l">
                      <p>ciblage flagship stores Parisien</p>
                    </Content>
                  </Boxes.BoxShadow>
                </Column4>

                <Column4 className="smallGap" style={{ paddingRight: 0, paddingLeft: 0 }}>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Audience</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>1,6<small>M</small></span>
                          <span>vues</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={75} />
                    </ProgressCircle>
                    <Content className="padding l">
                      <p>74k vues/jour</p>
                    </Content>
                  </Boxes.BoxShadow>
                </Column4>

                <Column4 className="smallGap" style={{ paddingRight: 0 }}>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Commandes</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>100<small>%</small></span>
                          <span>Satisfaction</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={100} />
                    </ProgressCircle>
                    <Content className="padding l">
                      <p>Satisfaction passants 100%</p>
                    </Content>
                  </Boxes.BoxShadow>
                </Column4>
              </RowSmallGap>
            </div>
          </Section>

          <Section>
            <div>
              <Boxes.Box2Columns style={{ padding: 0, maxHeight: '40rem' }}>
                <div>
                  <img style={{
                    margin: '0 auto', display: 'block'
                  }} src={data.placeholder.edges[0].node.publicURL} alt="casio" />
                </div>
              </Boxes.Box2Columns>
              <Boxes.Box2Columns>
                <div>
                  <Content className="full padding s">
                    <p>"Une très belle réussite pour cette campagne d'exception. Message in a Window
                    nous a permis de rencontrer Casio et leur campagne physique et digitale créative a généré l'engouement"</p>
                    <span className="author">Fleux, Paris 4</span>
                  </Content>
                  <Content className="full padding s">
                    <p>"Création en dentelle dans un décor urbain extrêmement valorisant pour
                    Casio et pour Chez Maman. À refaire."</p>
                    <span className="author">Chez Maman, Paris 2</span>
                  </Content>
                </div>
              </Boxes.Box2Columns>
            </div>
          </Section>

          <Section className="bottom main" style={{
            padding: '0 0 10rem'
          }}>
            <div>
              <Boxes.BoxLargeShadow style={{ width: '100%' }}>
                <div>
                  <Content>
                    <Cta.ChevronFocus href={`https://www.messageinawindow.com/blog/exclusif-message-in-a-window-x-casio-chez-fleux-paris/`} title="Lire l'article sur la campagne Casio">
                      Lire l'article sur la campagne Casio
                    </Cta.ChevronFocus>
                  </Content>
                </div>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>
        </PageWrapper>
      </Layout>
    )
  }
}

export const query = graphql`
  query {
    logo: allFile (
      filter: {
        relativePath: {eq: "logos/customer-cases/casio.svg"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    placeholder: allFile (
      filter: {
        relativePath: {eq: "cas-clients/casio.png"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __commonBackgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "backgrounds/common"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
  }
`